import React, { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import "../../styles.css";
import { GOOGLE_API_KEY, API_IP } from "../../global_variables";
import { axiosReqConfig } from "../../functions/axiosRequest";
import PromptModal from "../ReuseComponent/PromptModal";
import Autocomplete from "react-google-autocomplete";

// The dropdown menu for services. It is located in the navbar.
const AddPatientModal = ({ handleClose, toggleRefresh, showModal }) => {
  const [currentStage, setCurrentStage] = useState(0);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [address, setAddress] = useState("");
  const [unit, setUnit] = useState("");
  const [city, setCity] = useState("");
  const [province, setProvince] = useState("");
  const [country, setCountry] = useState("Canada");
  const [postalCode, setPostalCode] = useState("");
  const [selectedGender, setSelectedGender] = useState("");
  const [selectedRelationship, setSelectedRelationship] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedTypeResidence, setSelectedTypeResidence] = useState("");
  const [services, setServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [listYear, setListYear] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [geocode, setGeocode] = useState(null);

  const getGeocode = async (fullAddress) => {
    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json`,
        {
          params: {
            address: fullAddress, // The address to geocode
            key: GOOGLE_API_KEY,
          },
        },
      );

      if (response.data.status === "OK") {
        const location = response.data.results[0].geometry.location;
        setGeocode(location); // Save the geocode to state
        console.log("Geocode:", location); // { lat: ..., lng: ... }
      } else {
        console.error("Geocoding failed:", response.data.status);
        throw "your address is invalid. Check the address and try again.";
      }
    } catch (error) {
      throw ("Error fetching geocode:", error);
    }
  };
  //

  const handlePlaceSelected = (place) => {
    setCity("");
    setProvince("");
    setPostalCode("");
    setUnit("");

    const addressComponents = place.address_components;

    let streetNumber = "";
    let route = "";
    let extractedUnit = "";

    if (addressComponents) {
      addressComponents.forEach((component) => {
        const types = component.types;

        if (types.includes("subpremise")) extractedUnit = component.long_name;

        if (types.includes("street_number")) streetNumber = component.long_name;
        if (types.includes("route")) route = component.long_name;

        if (types.includes("locality")) setCity(component.long_name);
        if (types.includes("administrative_area_level_1"))
          setProvince(component.long_name);
        if (types.includes("country")) setCountry(component.long_name);
        if (types.includes("postal_code")) setPostalCode(component.long_name);
      });
    }

    if (!extractedUnit && place.name) {
      const unitRegex = /(?:#|Apt|Unit|Suite)\s?([0-9A-Za-z]+)/i;
      const match = place.name.match(unitRegex);
      if (match) extractedUnit = match[1];
    }
    setUnit(extractedUnit);

    if (streetNumber && route) {
      setAddress(`${streetNumber} ${route}`);
    } else {
      let cleanName = place.name
        .replace(/(?:#|Apt|Unit|Suite)\s?[0-9A-Za-z]+/i, "")
        .trim();
      cleanName = cleanName.split(",")[0];
      setAddress(cleanName);
    }
    if (place.geometry && place.geometry.location) {
      setGeocode({
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      });
    }
  };

  const handleInputChange = (e, setInput, type) => {
    const value = e.target.value;

    const regexMap = {
      name: /^[A-Za-z\s]*$/, // For names: allow only alphabets and spaces
      address: /^[A-Za-z0-9\s]*$/,
      postalCode: /^[A-Za-z0-9\s]*$/, // For Canadian postal code
    };

    const regex = regexMap[type];
    if (regex.test(value)) {
      setInput(value);
    }
  };

  async function getAllServices() {
    const response = await axios.get(`${API_IP}/api/services`); // Update with your API endpoint
    const objects = response.data.map((element, index) => ({
      id: index + 1, // Unique ID starting from 1
      name: element.care_service_name, // Name from the array element
      selected: false, // Default selected value
    }));
    setServices(objects);
  }
  function generateArrayOfYears() {
    var max = new Date().getFullYear();
    var min = max - 100;
    var years = [];

    for (var i = max; i >= min; i--) {
      years.push(i);
    }
    setListYear(years);
  }
  const stages = ["1.Identity", "2.Address", "3.Services", "4.Summary"];
  const typeOfResidenceList = ["House", "Apartment"];
  const relationshipList = [
    "Others",
    "Self",
    "Parent",
    "Child",
    "Grandparent",
    "Friend",
    "Spouse",
  ];
  const genders = ["I prefered not to say", "Male", "Female"];

  const handleCloseButton = () => {
    setFirstName("");
    setLastName("");
    setSelectedRelationship("");
    setSelectedGender("");
    setSelectedServices([]);
    setSelectedTypeResidence("");
    setSelectedYear("");
    setGeocode([]);
    setProvince("");
    setAddress("");
    setCity("");
    setIsLoading(false);
    setIsAlertVisible(false);
    setUnit("");
    setCountry("Canada");
    setPostalCode("");
    setCurrentStage(0);
    handleClose();
  };

  async function sendRequestNewPatient() {
    setIsLoading(true);
    const finalAddress = unit ? `${unit}-${address}` : address;
    const sendRequest = await axiosReqConfig(`${API_IP}/api/patient`, "post", {
      //body of the request
      first_name: firstName,
      last_name: lastName,
      additional_note: "",
      care_service: "",
      relationship: selectedRelationship,
      birth_year: selectedYear,
      address: finalAddress,
      city: city,
      province: province,
      country: country,
      gender: selectedGender,
      residence: selectedTypeResidence,
      services: selectedServices,
      lat: geocode.lat,
      lng: geocode.lng,
    });
    setTimeout(() => {
      toggleRefresh();
      setIsAlertVisible(true);
      setIsLoading(false);
    }, 2000);
  }

  const handleNextStep = async () => {
    if (currentStage == 1) {
      if (!geocode || geocode.lat === undefined) {
        try {
          await getGeocode(
            `${address}, ${city}, ${province}, ${country} ${postalCode}`,
          );
        } catch (error) {
          alert(error);
          return;
        }
      }
    } else if (currentStage == 3) {
      await sendRequestNewPatient();
    }
    if (currentStage < stages.length - 1) {
      setCurrentStage(currentStage + 1);
    }
  };

  const handleBackStep = () => {
    if (currentStage > 0) {
      setCurrentStage(currentStage - 1);
    }
  };

  const handleCheckboxService = (e, index) => {
    const value = e.target.name;
    if (services[index].selected == false) {
      let newArr = [...services];
      newArr[index].selected = true;
      setSelectedServices((oldArray) => [...oldArray, newArr[index].name]);
      console.log(newArr);
      setServices(newArr);
    } else {
      let newArr = [...services];
      newArr[index].selected = false;
      setSelectedServices((oldArray) => {
        return oldArray.filter((service) => service !== newArr[index].name);
      });
      console.log(newArr);
      setServices(newArr);
    }
  };

  const ServiceItem = ({ service, index }) => {
    return (
      <div className="patient-modal-checkbox-item">
        <div>
          <input
            type="checkbox"
            id={index}
            name={service.name}
            checked={service.selected}
            onChange={(e) => handleCheckboxService(e, index)}
            className="patient-modal-checkbox"
          />
        </div>
        <div>{service.name}</div>
      </div>
    );
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      generateArrayOfYears();
      getAllServices();
    }
    return () => {
      isMounted = false;
    };
  }, []);
  if (!showModal) {
    return null; // Return null if the modal is not open
  }

  return (
    <div className="startTime-modal-overlay" onClick={handleCloseButton}>
      {!isLoading ? (
        <div
          className="patient-modal-container"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="patient-modal-header">
            <h1>Add New Member</h1>
            <p>
              Complete all information accordingly and wait for the department’s
              confirmation.
            </p>
          </div>

          <div className="patient-modal-stages">
            <ul>
              {stages.map((stage, index) => (
                <li
                  key={index}
                  className={`patient-modal-stage ${
                    currentStage === index ? "patient-modal-active" : ""
                  }`}
                >
                  {stage}
                </li>
              ))}
            </ul>
          </div>

          <div className="patient-modal-body">
            {currentStage === 0 && (
              <div className="patient-modal-section">
                <h2>Member Information</h2>
                <div className="patient-modal-form-group">
                  <label htmlFor="first-name">First Name*</label>
                  <input
                    type="text"
                    id="first-name"
                    value={firstName}
                    onChange={(e) => handleInputChange(e, setFirstName, "name")}
                    className="patient-modal-form-input"
                    placeholder="Enter first name"
                  />
                </div>
                <div className="patient-modal-form-group">
                  <label htmlFor="last-name">Last Name*</label>
                  <input
                    type="text"
                    id="last-name"
                    value={lastName}
                    onChange={(e) => handleInputChange(e, setLastName, "name")}
                    placeholder="Enter last name"
                  />
                </div>
                <div className="patient-modal-gender-dropdown">
                  <label
                    htmlFor="gender"
                    className="patient-modal-gender-label"
                  >
                    Gender
                  </label>
                  <select
                    id="gender"
                    className="patient-modal-gender-select"
                    value={selectedGender}
                    onChange={(e) => setSelectedGender(e.target.value)}
                  >
                    <option value="" disabled>
                      Select Gender
                    </option>
                    {genders.map((gender, index) => {
                      return (
                        <option key={index} value={index}>
                          {gender}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="patient-modal-gender-dropdown">
                  <label
                    htmlFor="gender"
                    className="patient-modal-gender-label"
                  >
                    Relationship to Member
                  </label>
                  <select
                    id="relationship"
                    className="patient-modal-gender-select"
                    value={selectedRelationship}
                    onChange={(e) => setSelectedRelationship(e.target.value)}
                  >
                    <option value="" disabled>
                      Select Relationship
                    </option>
                    {relationshipList.map((relation, index) => {
                      return (
                        <option key={index} value={index}>
                          {relation}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="patient-modal-gender-dropdown">
                  <label
                    htmlFor="gender"
                    className="patient-modal-gender-label"
                  >
                    Birth Year
                  </label>
                  <select
                    id="relationship"
                    className="patient-modal-gender-select"
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                  >
                    <option value="" disabled>
                      Select Year
                    </option>
                    {listYear.map((year, index) => {
                      return (
                        <option key={index} value={year}>
                          {year}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            )}

            {currentStage === 1 && (
              <div className="patient-modal-section">
                <h2>Address</h2>
                <div className="patient-modal-form-group">
                  <label>Address</label>
                  <Autocomplete
                    apiKey={GOOGLE_API_KEY}
                    onPlaceSelected={(place) => handlePlaceSelected(place)}
                    options={{
                      types: ["address"], // Chỉ tìm kiếm địa chỉ nhà cụ thể
                      componentRestrictions: { country: "ca" }, // Giới hạn ở Canada (vì mặc định state là Canada)
                    }}
                    value={address}
                    onChange={(e) => setAddress(e.target.value)} // Cho phép gõ tay nếu muốn
                    className="patient-modal-form-input" // Dùng lại class CSS cũ để không bị vỡ giao diện
                    placeholder="Enter address"
                  />
                </div>
                <div className="patient-modal-form-group">
                  <label>Apt / Unit # (Optional)</label>
                  <input
                    type="text"
                    value={unit}
                    onChange={(e) => setUnit(e.target.value)}
                    placeholder="e.g. 101"
                    className="patient-modal-form-input" // Dùng class để style giống các ô khác
                  />
                </div>
                <div className="patient-modal-form-group">
                  <label>City</label>
                  <input
                    type="text"
                    id="city"
                    value={city}
                    onChange={(e) => handleInputChange(e, setCity, "name")}
                    placeholder="Enter city"
                  />
                </div>
                <div className="patient-modal-form-group">
                  <label>Province</label>
                  <input
                    type="text"
                    id="province"
                    value={province}
                    onChange={(e) => handleInputChange(e, setProvince, "name")}
                    placeholder="Enter province"
                  />
                </div>
                <div className="patient-modal-form-group">
                  <label>Country</label>
                  <input
                    type="text"
                    id="country"
                    value={country}
                    onChange={(e) => handleInputChange(e, setCountry, "name")}
                    placeholder="Enter country"
                  />
                </div>
                <div className="patient-modal-form-group">
                  <label>Postal Code</label>
                  <input
                    type="text"
                    id="postal code"
                    value={postalCode}
                    onChange={(e) =>
                      handleInputChange(e, setPostalCode, "postalCode")
                    }
                    placeholder="Enter postal code"
                  />
                </div>
                <div className="patient-modal-gender-dropdown">
                  <label
                    htmlFor="gender"
                    className="patient-modal-gender-label"
                  >
                    Type Of Residence
                  </label>
                  <select
                    id="relationship"
                    className="patient-modal-gender-select"
                    value={selectedTypeResidence}
                    onChange={(e) => setSelectedTypeResidence(e.target.value)}
                  >
                    <option value="" disabled>
                      Select Type
                    </option>
                    {typeOfResidenceList.map((type, index) => {
                      return (
                        <option key={index} value={index}>
                          {type}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            )}

            {currentStage === 2 && (
              <div className="patient-modal-section">
                <h2>What services are you interested in?</h2>
                <div className=".patient-modal-checkbox-group">
                  {services.map((service, index) => {
                    return (
                      <ServiceItem
                        key={index}
                        index={index}
                        service={service}
                      />
                    );
                  })}
                </div>
              </div>
            )}

            {currentStage === 3 && (
              <div className="patient-modal-section">
                <h2>Summary</h2>
                <div className="patient-modal-summary">
                  <div className="patient-modal-form-group">
                    <label>First Name</label>
                    <p>{firstName}</p>
                  </div>
                  <div className="patient-modal-form-group">
                    <label>Last Name</label>
                    <p>{lastName}</p>
                  </div>
                  <div className="patient-modal-form-group">
                    <label>Gender</label>
                    <p>{genders[selectedGender]}</p>
                  </div>
                  <div className="patient-modal-form-group">
                    <label>Year</label>
                    <p>{selectedYear}</p>
                  </div>
                  <div className="patient-modal-form-group">
                    <label>Relationship to Member</label>
                    <p>{relationshipList[selectedRelationship]}</p>
                  </div>
                  <div className="patient-modal-form-group">
                    <label>Full Address</label>
                    <p>
                      {unit ? `${unit}-` : ""}
                      {address}, {city} {province}, {country} {postalCode}
                    </p>
                  </div>
                  <div className="patient-modal-form-group">
                    <label>Type Of Residence</label>
                    <p>{typeOfResidenceList[selectedTypeResidence]}</p>
                  </div>
                  {/* <div className="patient-modal-form-group">
                    <label>Interested Services</label>
                    <div className="patient-modal-service-list">
                      {services.map((service, index) => {
                        console.log()
                        if (services.selected === true) {
                          console.log(service.name);
                          return (
                            <>
                              <p>{service.name}, </p>
                            </>
                          );
                        } else {
                          return <></>;
                        }
                      })}
                    </div>
                  </div> */}
                </div>
              </div>
            )}
          </div>

          <div className="patient-modal-footer">
            {currentStage === 0 ? (
              <div></div>
            ) : (
              <button
                className="patient-modal-next-button"
                onClick={handleBackStep}
              >
                Back
              </button>
            )}
            <button
              className="patient-modal-next-button"
              onClick={handleNextStep}
              disabled={
                currentStage === stages.length ||
                (currentStage == 0 &&
                  (firstName == "" ||
                    lastName == "" ||
                    selectedGender == "" ||
                    selectedRelationship == "" ||
                    selectedYear == "")) ||
                (currentStage == 1 &&
                  (address == "" ||
                    city == "" ||
                    province == "" ||
                    country == "" ||
                    postalCode == "" ||
                    selectedTypeResidence == ""))
              }
            >
              {currentStage === stages.length - 1 ? "Finish" : "Next Step"}
            </button>
          </div>
        </div>
      ) : (
        <>
          <img
            src={require("../../images/loading_icon.gif")}
            alt="Clock icon"
          />
        </>
      )}
      <PromptModal
        title={"You have successfully added the member."}
        type="alert"
        showModal={isAlertVisible}
        handleClose={handleCloseButton}
        isLoading={isLoading}
      />
    </div>
  );
};

export default AddPatientModal;
